<div class="container-fluid bg-white rounded pt-1">
    <list-header
        (onSearchConfirmed)="onSearchConfirmed($event)"
        (onSyncProducts)="onSyncProducts()"
        [viewLabel]="'NURSERY_LIST_COMPONENT_NAME' | translate"
        [showSyncProducts]="true"
    ></list-header>
    <tablelist [tableInfo]="tableInfo" (onHeaderClicked)="onHeaderClick($event)"></tablelist>
    <pagination [listInfo]="listInfo" (onPageChanged)="onPageChanged($event)"></pagination>
</div>
